module.exports = {
	"_args": [
		[
			{
				"raw": "proj4@^2.4.3",
				"scope": null,
				"escapedName": "proj4",
				"name": "proj4",
				"rawSpec": "^2.4.3",
				"spec": ">=2.4.3 <3.0.0",
				"type": "range"
			},
			"F:\\workspace\\copy\\HMap"
		]
	],
	"_cnpm_publish_time": 1488570791097,
	"_from": "proj4@>=2.4.3 <3.0.0",
	"_id": "proj4@2.4.3",
	"_inCache": true,
	"_location": "/proj4",
	"_nodeVersion": "6.9.2",
	"_npmOperationalInternal": {
		"host": "packages-18-east.internal.npmjs.com",
		"tmp": "tmp/proj4-2.4.3.tgz_1488570790416_0.3068596587982029"
	},
	"_npmUser": {
		"name": "cwmma",
		"email": "calvin.metcalf@gmail.com"
	},
	"_npmVersion": "4.0.5",
	"_phantomChildren": {},
	"_requested": {
		"raw": "proj4@^2.4.3",
		"scope": null,
		"escapedName": "proj4",
		"name": "proj4",
		"rawSpec": "^2.4.3",
		"spec": ">=2.4.3 <3.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "http://r.cnpmjs.org/proj4/download/proj4-2.4.3.tgz",
	"_shasum": "f3bb7e631bffc047c36a1a3cc14533a03bbe9969",
	"_shrinkwrap": null,
	"_spec": "proj4@^2.4.3",
	"_where": "F:\\workspace\\copy\\HMap",
	"author": "",
	"bugs": {
		"url": "https://github.com/proj4js/proj4js/issues"
	},
	"contributors": [
		{
			"name": "Mike Adair",
			"email": "madair@dmsolutions.ca"
		},
		{
			"name": "Richard Greenwood",
			"email": "rich@greenwoodmap.com"
		},
		{
			"name": "Calvin Metcalf",
			"email": "calvin.metcalf@gmail.com"
		},
		{
			"name": "Richard Marsden",
			"url": "http://www.winwaed.com"
		},
		{
			"name": "T. Mittan"
		},
		{
			"name": "D. Steinwand"
		},
		{
			"name": "S. Nelson"
		}
	],
	"dependencies": {
		"mgrs": "1.0.0",
		"wkt-parser": "^1.1.3"
	},
	"description": "Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.",
	"devDependencies": {
		"chai": "~1.8.1",
		"curl": "git://github.com/cujojs/curl.git",
		"grunt": "~0.4.2",
		"grunt-cli": "~0.1.13",
		"grunt-contrib-connect": "~0.6.0",
		"grunt-contrib-jshint": "~1.1.0",
		"grunt-contrib-uglify": "~0.11.1",
		"grunt-mocha-phantomjs": "~0.4.0",
		"grunt-rollup": "^1.0.1",
		"istanbul": "~0.2.4",
		"mocha": "~1.17.1",
		"rollup": "^0.41.4",
		"rollup-plugin-json": "^2.0.1",
		"rollup-plugin-node-resolve": "^2.0.0",
		"tin": "~0.4.0"
	},
	"directories": {
		"test": "test",
		"doc": "docs"
	},
	"dist": {
		"shasum": "f3bb7e631bffc047c36a1a3cc14533a03bbe9969",
		"size": 116887,
		"noattachment": false,
		"tarball": "http://r.cnpmjs.org/proj4/download/proj4-2.4.3.tgz"
	},
	"gitHead": "e975a5462ad7abb23e33ea75281eb749e77e1510",
	"homepage": "https://github.com/proj4js/proj4js#readme",
	"license": "MIT",
	"main": "dist/proj4-src.js",
	"maintainers": [
		{
			"name": "ahocevar",
			"email": "andreas.hocevar@gmail.com"
		},
		{
			"name": "cwmma",
			"email": "calvin.metcalf@gmail.com"
		}
	],
	"module": "lib/index.js",
	"name": "proj4",
	"optionalDependencies": {},
	"publish_time": 1488570791097,
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git://github.com/proj4js/proj4js.git"
	},
	"scripts": {
		"build": "grunt",
		"build:tmerc": "grunt build:tmerc",
		"test": "npm run build && istanbul test _mocha test/test.js"
	},
	"version": "2.4.3"
};


//////////////////
// WEBPACK FOOTER
// ./~/proj4/package.json
// module id = 108
// module chunks = 0